import { required } from 'vuelidate/lib/validators'

export default {
  price: {
    company_address_id: {
      required
    },
    kind: {
      required
    },
    validity: {
      required
    },
    value: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/validations.js